import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMemo, faArrowLeft, faArrowRightFromBracket} from '@fortawesome/pro-light-svg-icons';
import {useIntercom} from 'react-use-intercom';
import {DropdownMenuSeparator} from '@src/components/shadcn/dropdown-menu';
import redirectViaSubmit from '@src/util/redirectViaSubmit';
import {NavItem} from './types';

const useSafeIntercom = () => {
  try {
    return useIntercom();
  } catch (error) {
    // Return default values when Intercom is not available
    return {
      hardShutdown: () => {},
    };
  }
};

type SimpleLink = {
  absoluteRoot: string;
  relativePath: string;
  label: string;
};

interface NavFooterDropdownContentProps {
  accountNavItems: NavItem[];
  backToAdminItem: SimpleLink | undefined;
  logoutItem: SimpleLink | undefined;
}

const NavFooterDropdownContent: React.FC<NavFooterDropdownContentProps> = ({
  accountNavItems,
  backToAdminItem,
  logoutItem,
}) => {
  const {hardShutdown} = useSafeIntercom();
  return (
    <>
      <p className="font-semibold text-sm text-peppercorn-800 p-2 h-8 m-0">My Account</p>
      <DropdownMenuSeparator />
      <div className="flex flex-col gap-3 p-3">
        {accountNavItems.map(({label, to}) => (
          <a
            key={to}
            href={to}
            className="flex justify-start gap-2 items-center text-peppercorn-800"
          >
            <FontAwesomeIcon className="text-sm text-peppercorn-800" icon={faMemo} />
            <span className="text-sm text-peppercorn-800">{label}</span>
          </a>
        ))}
        <DropdownMenuSeparator />
        {backToAdminItem && (
          <a
            href={`${backToAdminItem.absoluteRoot}${backToAdminItem.relativePath}`}
            className="flex justify-start gap-2 items-center text-peppercorn-800"
          >
            <FontAwesomeIcon className="text-sm text-peppercorn-800" icon={faArrowLeft} />
            <span className="text-sm text-peppercorn-800">{backToAdminItem.label}</span>
          </a>
        )}
        {logoutItem && (
          <a
            href={`${logoutItem.absoluteRoot}${logoutItem.relativePath}`}
            className="flex justify-start gap-2 items-center text-peppercorn-800"
            onClick={e => {
              e.preventDefault();
              hardShutdown();
              redirectViaSubmit(`${logoutItem.absoluteRoot}${logoutItem.relativePath}`, 'DELETE');
            }}
          >
            <FontAwesomeIcon
              className="text-sm text-peppercorn-800"
              icon={faArrowRightFromBracket}
            />
            <span className="text-sm text-peppercorn-800">{logoutItem.label}</span>
          </a>
        )}
      </div>
    </>
  );
};

export default NavFooterDropdownContent;
